// extracted by mini-css-extract-plugin
export default {"button":"ShowAllButton_button__BCSz-"};